<template>
    <div>
      <div class="g-card" style="margin-bottom: 20px">
        <div class="scrm-intro">
          <div class="flex item-center">
            <div class="title">人群管理</div>
            <div class="subTitle">
              <a
                href="https://doc.weixin.qq.com/doc/w3_ABcAHAZjANgHz8HbFT2SjKnS39hNP?scode=APgAlAcrAAgPIm0W0d"
                target="_blank"
                ><span class="hmicon icon-dingdan"></span>功能介绍</a
              >
            </div>
          </div>
          <div class="content mt10">
            客户分群精准圈选目标客户，通过人群画像全方位洞察客户，进而为客户群量身定制运营方案，最终使用人群运营/营销画布精准触达客户，提升客户活跃和消费转化。
          </div>
        </div>
      </div>
      <el-row :gutter="20" style="min-height: 400px">
        <el-col :span="6" :xs="24">
          <div class="left-content">
            <el-button type="primary" @click="addType" style="width: 100%">
              新增分类
            </el-button>
            <div class="mt10 mb10 flex">
              <el-input
                v-model.trim="searchConditions.queryKeywords"
                placeholder="请输入分类名称进行过滤"
                class="flex-1"
              />
              <el-button
                type="primary"
                @click="searchType"
                size="mini"
                class="ml10"
              >
                查询
              </el-button>
            </div>
            <!-- default-expand-all -->
            <el-tree
              ref="tree"
              :data="tagAttributeList"
              :props="defaultProps"
              :expand-on-click-node="false"
              :highlight-current="true"
              :current-node-key="currentLivingId"
              node-key="id"
              :load="loadAttributeNode"
              lazy
              @node-click="handleNodeClick"
            >
              <template v-slot="{ node, data }">
                <div
                  class="tree-label flex item-center"
                  :class="{ system: data.categoryType === 'System' }"
                >
                  <span
                    class="hmicon icon-xitongshezhi2x system-icon"
                    v-if="data.categoryType === 'System'"
                  ></span>
                  <!-- <span
                    class="iconfontScrm"
                    :class="data.categoryIcon"
                    v-else
                  ></span> -->
                  <hm-svg v-else :iconClass="data.categoryIcon||''" />{{ node.label }}
                  <el-dropdown
                    class="dropdown"
                    @command="onGroupCommand($event, node)"
                    v-if="node.level === 1"
                    :hide-timeout="1500"
                  >
                    <span class="dot">
                      <i class="el-icon-more content-icon"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="groupEdit"
                        >修改分组</el-dropdown-item
                      >
                      <!-- <el-dropdown-item command="groupRemove">删除分组</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!-- <div
                      class="iconfontScrm icon-icon-edit ml20"
                      v-if="node.level === 1"
                      @click="editType(node)"
                    ></div> -->
                </div>
              </template>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="g-card marginleft0">
            <el-button type="primary" @click="addPerson()" class="mr20">
              新建动态人群
            </el-button>
            <el-button type="primary" @click="addPersonStatic()" class="mr20">
              新建静态人群
            </el-button>
          </div>
          <div class="g-card marginleft0">
            <el-radio-group v-model="listType" size="small" @change="listTypeTab">
              <el-radio-button label="person"
                ><span class="font14">动态人群列表</span></el-radio-button
              >
              <el-radio-button label="personStatic"
                ><span class="font14">静态人群列表</span></el-radio-button
              >
            </el-radio-group>
            <span style="margin-left: 50px">
              <el-input size="small" placeholder="请输入人群名称" v-model="calcName" @enter="listTypeTab" clearable></el-input>
              <el-button size="small" style="margin-left: 10px" type="primary" @click="listTypeTab">查询</el-button>
            </span>
            <div class="mt20" v-if="listType === 'person'">
              <div v-if="list && list.length">
                <el-table @cell-dblclick="handleCellDBClick" ref="table" :data="list" v-if="resetForm">
                  <el-table-column
                    align="left"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                  ></el-table-column>
                  <el-table-column align="left" prop="calcName" label="人群名称">
                    <template slot-scope="scope">
                      <div
                        v-if="!scope.row.showInput"
                        class="text-overflow"
                        :title="scope.row.calcName"
                        >{{ scope.row.calcName }}</div
                      >
                      <el-input v-else v-model="scope.row.calcName" :maxlength="30" size="small" @focus="handleFocus(scope.row)" @blur="handleInputBlur(scope.row)" clearable></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="left"
                    prop="resultRowsNum"
                    label="最近覆盖人数"
                  >
                  </el-table-column>
                  <el-table-column
                    align="left"
                    prop="updateTime"
                    label="最后一次执行时间"
                  >
                  </el-table-column>
                  <el-table-column
                    align="left"
                    prop="operatingEmployeeId"
                    label="最后一次操作人"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <el-button
                          type="text"
                          size="small"
                          class="mr20"
                          @click="tagDetail3(scope.row)"
                        >
                          查看
                        </el-button>
                        <el-button
                          size="small"
                          type="text"
                          @click="showUpdate(scope.row)"
                          >更新</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="queryReportsList(scope.row)"
                          >查看人群记录</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          class="warning"
                          @click="handleDel(scope.row)"
                          >删除</el-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="hm-pagination">
                  <el-pagination
                    background
                    :total="total"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                  ></el-pagination>
                </div>
              </div>
              <div v-else class="g-tip-color ac">暂无数据</div>
            </div>
            <div class="mt20" v-if="listType === 'personStatic'">
              <div v-if="listStatic && listStatic.length">
                <el-table
                  ref="table"
                  :data="listStatic"
                  style="width: 100%"
                  v-if="resetForm"
                  @cell-dblclick="handleCellDBClick"
                >
                  <el-table-column
                    align="left"
                    type="index"
                    label="序号"
                    width="50"
                    :index="index => index + (currentPage - 1) * pageSize + 1"
                  ></el-table-column>
                  <el-table-column align="left" prop="tagName" label="人群名称">
                    <template slot-scope="scope">
                      <div
                        v-if="!scope.row.showInput"
                        class="text-overflow"
                        :title="scope.row.tagName"
                        >{{ scope.row.tagName }}</div
                      >
                      <el-input v-else v-model="scope.row.tagName" :maxlength="30" size="small" @focus="handleFocus(scope.row)" @blur="handleInputBlur(scope.row)" clearable></el-input>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="num"
                    label="最近覆盖人数"
                  >
                  </el-table-column> -->
                  <el-table-column
                    align="left"
                    prop="updateTime"
                    label="最后一次执行时间"
                  >
                  </el-table-column>
                  <!-- <el-table-column
                    header-align="center"
                    align="center"
                    label="过期时间"
                    prop="name"
                  >
                  </el-table-column> -->
                  <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scope">
                      <div class="flex flex-center">
                        <el-button
                          type="text"
                          size="small"
                          class="mr20"
                          @click="exportTagDataCsv(scope.row)"
                        >
                          下载
                        </el-button>
                        <el-button
                          type="text"
                          size="small"
                          class="mr20"
                          @click="tagDetail(scope.row)"
                        >
                          查看详情
                        </el-button>
                        <el-button
                          size="small"
                          type="text"
                          class="warning"
                          @click="handleDel(scope.row)"
                          >删除</el-button
                        >
                        <!-- <el-button size="small" type="text" @click="showUpdate(scope.row)"
                          >更新</el-button
                        >
                        <el-button
                          size="small"
                          type="text"
                          @click="queryReportsList(scope.row)"
                          >查看人群记录</el-button
                        > -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="hm-pagination">
                  <el-pagination
                    background
                    :total="total"
                    @current-change="paging"
                    @size-change="handleSizeChange"
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="currentPage"
                  ></el-pagination>
                </div>
              </div>
              <div v-else class="g-tip-color ac">暂无数据</div>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-dialog
        :title="(ruleForm.id ? '修改' : '添加') + '分类'"
        :with-header="false"
        :wrapperClosable="false"
        class="create-tag-drawer"
        :visible.sync="categoryNameVisble"
        :append-to-body="true"
        width="600px"
      >
        <el-form
          label-width="120px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @submit.native.prevent
        >
          <el-form-item label="分类名称" prop="categoryName">
            <el-input
              v-model.trim="ruleForm.categoryName"
              placeholder="请输入分类名称"
              class="flex-1"
              clearable
              maxlength="20"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="图标名称" prop="categoryIcon">
            <!-- <el-input
              v-model.trim="ruleForm.categoryIcon"
              placeholder="请输入图标名称"
              class="flex-1"
              clearable
            /> -->
            <el-select 
              ref="iconSelect"
              style="visibility: hidden"
              v-model.trim="ruleForm.categoryIcon"
              placeholder="请选择"
            >
              <el-option
                v-for="item in iconfontList"
                :key="item.font_class"
                :label="item.label"
                :value="item.font_class">
                <hm-svg :iconClass="item.font_class" />
              </el-option>
            </el-select>
            <div @click="handleSelectIcon" class="select-div">
              <hm-svg :iconClass="ruleForm.categoryIcon" />
            </div>
          </el-form-item>
          <el-form-item label="分类排序" prop="sortNum">
            <el-input
              v-model.trim="ruleForm.sortNum"
              placeholder="请输入分类排序"
              class="flex-1"
              clearable
              maxlength="6"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="hideAddType">取 消</el-button>
          <el-button type="primary" @click="addTypeSubmit('ruleForm')"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="人群记录"
        width="80%"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
      >
        <div class="table">
          <el-table
            stripe
            :data="reportsList"
            style="width: 100%"
            id="table"
            size="small"
            border
            :max-height="400"
          >
            <el-table-column
              align="left"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageReports - 1) * pageSizeReports + 1
              "
            ></el-table-column>
            <el-table-column
              align="left"
              prop="schedulingTypeName"
              label="人群包名称"
            >
            </el-table-column>
            <el-table-column align="left" prop="resultRowsNum" label="人群人数">
            </el-table-column>
            <el-table-column align="left" prop="schedulingTime" label="执行时间">
            </el-table-column>
            <el-table-column
              align="left"
              prop="operatingEmployeeId"
              label="操作人"
            >
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
              <template slot-scope="scope">
                <div class="flex flex-center">
                  <el-button
                    size="small"
                    type="text"
                    @click="exportTagDataCsv(scope.row)"
                    v-if="scope.row.resultRowsNum"
                    >下载</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    v-if="scope.row.resultRowsNum"
                    @click="showAnalyzeList(scope.row)"
                    >去分析</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalReports"
              @current-change="pagingReports"
              @size-change="handleSizeChangeReports"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPageReports"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="更新人群包"
        width="600px"
        :visible.sync="dialogVisibleReportResultName"
        :before-close="handleClose2"
      >
        <div>
          <div class="mb20">将按以下规则执行运算：</div>
          <div class="mb20">
            {{ currentRows.tagName }}
          </div>
          <div class="mb20">人群包命名</div>
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="reportResultName"
            placeholder="请输入人群包命名"
            size="small"
            class="ipt"
          ></el-input>
        </div>
        <span slot="footer" class="flex flex-center">
          <el-button type="primary" size="small" @click="updateDetail"
            >执行更新</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="更新人群包"
        width="600px"
        :visible.sync="dialogVisibleReportMsg"
        :before-close="handleClose2"
      >
        <div class="flex flex-center">
          <div class="mt20 mb20">请耐心等待一段时间，执行成功后状态将会更新</div>
        </div>
        <span slot="footer" class="flex flex-center">
          <el-button
            type="primary"
            size="small"
            @click="closeDialogVisibleReportMsg"
            >我知道了</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="人群查看"
        width="80vw"
        :visible.sync="dialogVisible3"
        :before-close="handleClose3"
        custom-class="tag-dialog"
      >
        <!-- <div class="flex flex-center" v-if="resetForm2"> -->
        <div class="" v-if="resetForm2">
          <!-- <div class="mt20 mb20"> -->
            <!-- <div class="mask">
  
            </div> -->
            <add-person isDetail :selectedMemo="selectedMemo"></add-person>
            <!-- <div
              class="lineHight16"
              v-if="selectedMemo"
              style="max-height: 500px"
            >
              <pre v-highlight>
                      <code class="lang-javascript">{{ selectedMemo }}</code>
                  </pre>
            </div> -->
            <!-- <template v-if="tagArr && tagArr.length">
              <div v-for="(item, ind) in tagArr" :key="ind">
                <div class="dialog-title">{{ item.categoryName }}</div>
                <div
                  class="dialog-content"
                  v-for="(tag, i) in item.tags"
                  :key="i"
                >
                  <div class="second_title">{{ tag.tagName }}</div>
                  <div class="second_content">
                    <el-tag v-for="(calc, num) in tag.calcValueList" :key="num">
                      {{ calc.name }}
                    </el-tag>
                  </div>
                </div>
              </div>
            </template> -->
            <!-- <div v-else>暂无数据</div> -->
          <!-- </div> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose3">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="分析列表"
        width="600px"
        :visible.sync="dialogVisible4"
        :before-close="handleClose4"
      >
        <div class="flex flex-wrap">
          <div class="mr20 mb20" v-for="(v, i) in analyzeList" :key="i">
            <el-button
              type="primary"
              @click="toAnalyze(v.itemValue, v.itemText)"
              >{{ v.itemText }}</el-button
            >
          </div>
        </div>
      </el-dialog>
  
      <el-dialog
        title='导出会员名单'
        :visible.sync='exportTypeDialog'
        width='630px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
        <div class="radio-wrap">
          <span class="radio-title mr10">导出类型：</span>
          <el-radio-group v-model="exportType" @change="exportTableCheckList=[]">
            <el-radio label="base">基础类型（主要导出会员手机号）</el-radio>
            <el-radio label="zdy">自定义类型</el-radio>
          </el-radio-group>
        </div>
        <div class="zdy-wrap" v-if="exportType==='zdy'">
          <div class="_title">导出表头选择</div>
          <el-checkbox-group v-model="exportTableCheckList">
            <el-checkbox :label="item.columnName" v-for="item in exportTypeList" :key="item.id">{{item.labelName}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <template slot='footer'>
          <el-button @click='exportTypeDialog = false' size='small'>取消</el-button>
          <el-button @click='handleConfirmExport' type='primary' size='small'>确定导出</el-button>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
import XLSX from "xlsx";
import axios from "axios";
import addPerson from "./addPerson.vue";
import { getCookie, setCookie } from "@/utils/utils";
import global from '@/global'
export default {
  components: { addPerson },
  data() {
    return {
      firstList: [],
      tagAttributeList: [],
      defaultProps: {
        label: "categoryName",
        isLeaf: (data, node) => {
          if (node.level === 1) {
            return true;
          }
          if (node.level === 2) {
            return true;
          }
        },
      },
      searchConditions: {
        queryKeywords: "",
      },
      ruleForm: {
        id: "",
        parentId: "",
        categoryName: "",
        categoryIcon: "icon-icon-renshu",
        sortNum: "",
      },
      rules: {
        parentId: [{ required: true, message: "必填项", trigger: "change" }],
        categoryName: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      categoryNameVisble: false,
      currentRow: {},
      node: {},
      tagList: [],
      nodeData: undefined,
      listStatic: [],
      list: [],
      currentLivingId: "",
      currentRows: {},
      reportResultName: "",
      dialogVisibleReportResultName: false,
      dialogVisibleReportMsg: false,
      dialogVisible: false,
      reportConfigIdList: [],
      reportsList: [],
      listType: "person",
      resolveFunc: function() {},
      parentId2: "",
      dialogVisible3: false,
      selectedMemo: "",
      totalReports: 0,
      currentPageReports: 1,
      pageSizeReports: 10,
      resetForm2: true,
      row: {},
      resetForm: true,
      dialogVisible4: false,
      reportsRow: "",
      analyzeList: [],
      tagArr: [],
      calcName: "",
      iconfontList: [],
      changeTableObj: {},
      exportTypeList: [],
      exportType: "base",
      exportRow: null,
      exportTableCheckList: [],
      exportTypeDialog: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryExportTagField();
  },
  mounted() {
    const iconfontList =
      getCookie({ key: "iconfontList", type: "session" }) || [];
    if (iconfontList.length) {
      this.iconfontList = iconfontList;
    } else {
      axios.get(global.iconfontJsonUrl).then(res => {
        const data = res.data.glyphs
        setCookie({key: "iconfontList", type: "session", data})
      })
    }
    
    this.dictItemsScrmGroupAnalysis();
  },
  methods: {
    queryExportTagField() {
      this.$store
        .dispatch("queryExportTagField", {
          templateCode: "exportTagDataList",
        })
        .then((res) => {
          if (res.code === "0") {
            this.exportTypeList = res.result;
          }
        });
    },
    searchType() {
      this.reloadTree();
    },
    handleNodeClick(data) {
      console.log("data:", data);
      this.calcName = "";
      this.nodeData = data;
      this.switchTab();
    },
    addType() {
      this.ruleForm.id = "";
      this.ruleForm.categoryName = "";
      this.ruleForm.categoryIcon = "icon-icon-renshu";
      this.ruleForm.sortNum = "";
      this.categoryNameVisble = true;
    },
    editGroup(row) {
      console.log("row.data:", row.data);
      this.ruleForm = JSON.parse(JSON.stringify(row.data));
      this.categoryNameVisble = true;
    },
    tagDetail(row) {
      this.$router.push({
        name: "AddPersonStatic",
        query: {
          id: row.id,
        },
      });
    },
    tagDetail3(row) {
      this.resetForm2 = false;
      this.$nextTick(() => {
        this.resetForm2 = true;
        this.currentRow = row;
        if (this.currentRow.selectedMemo) {
          this.selectedMemo = JSON.parse(this.currentRow.selectedMemo);
        } else {
          this.selectedMemo = "";
        }
        console.log("this.selectedMemo:", this.selectedMemo);
        this.dialogVisible3 = true;
      });
    },
    tagRemove() {
      console.log("删除");
    },
    addTypeSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            level: 1,
          };
          const ruleForm = JSON.parse(JSON.stringify(this.ruleForm));
          Object.assign(params, ruleForm);
          let url = "sysCategoryFrontendDisplayInfoAdd";
          if (this.ruleForm.id) {
            Object.assign(params, { id: this.ruleForm.id });
            url = "sysCategoryFrontendDisplayInfoUpdateById";
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
            this.categoryNameVisble = false;
            this.reloadTree();
            // this.$router.go(0)
          });
        }
      });
    },
    hideAddType() {
      this.categoryNameVisble = false;
    },
    addPerson() {
      if (!this.nodeData) {
        this.$message({
          message: "请先新增分类",
          type: "success",
        });
        return;
      }
      this.$router.push({
        path:'/memberOperation/memberManagement/addPerson',
        query: {
          sysCategoryFrontendDisplayId: this.nodeData.attrId,
        },
      });
    },
    addPersonStatic() {
      this.$router.push({
        name: "AddPersonStatic",
        query: {
          sysCategoryFrontendDisplayId: this.nodeData.attrId,
        },
      });
    },
    reloadTree() {
      this.node.childNodes = [];
      this.loadAttributeNode(this.node, this.resolveFunc);
    },
    loadAttributeNode(node, resolve) {
      // 一级节点处理
      if (node.level === 0) {
        this.node = node;
        this.resolveFunc = resolve;
        this.queryParentId2().then((res) => {
          this.requestAttributeTree(resolve);
        });
      }
      // 其余节点处理
      if (node.level >= 1) {
        // 注意！把resolve传到你自己的异步中去
        this.getAttributeIndex(node, resolve);
      }
    },
    // 首次加载属性数
    requestAttributeTree(resolve) {
      this.$store
        .dispatch(
          "querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId",
          {
            parentId: this.parentId2,
            level: 1,
            queryKeywords: this.searchConditions.queryKeywords,
            pageNo: 1,
            pageSize: 9999,
          }
        )
        .then((res) => {
          let data = res.result.records;
          this.firstList = data;
          data = data.sort(this.sortBy("sortNum"));
          data.forEach((v) => {
            v.attrId = v.id;
            v.attrValue = v.categoryName;
            v.disabled = true;
          });
          this.currentLivingId = this.firstList[0].id;
          console.log("this.currentLivingId:", this.currentLivingId);
          this.$nextTick(function() {
            this.$refs.tree.setCurrentKey(this.currentLivingId);
          });
          this.nodeData = this.firstList[0];
          this.switchTab();
          resolve(data);
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    getAttributeIndex(node, resolve) {
      if (node.level > 1) return resolve([]);
      this.$store
        .dispatch("tagCustomSourceInfoQueryPageList", {
          sysCategoryFrontendDisplayId: node.data.attrId,
          pageNo: 1,
          pageSize: 9999,
          tagName: this.calcName,
        })
        .then((res) => {
          if (res.result && res.result.records) {
            const data = res.result.records;
            data.forEach((v) => {
              v.categoryName = v.tagName;
              v.disabled = true;
              v.leaf = true;
              v.level = 2;
            });
            resolve(data);
          }
        })
        .catch((err) => {
          throw new Error(err);
        });
    },
    async queryListStatic() {
      const { result } = await this.$store.dispatch(
        "tagCustomSourceInfoQueryPageList",
        {
          sysCategoryFrontendDisplayId: this.nodeData.attrId,
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          tagName: this.calcName,
        }
      );
      if (result) {
        const { records, total } = result;
        this.listStatic = records;
        this.total = total;
      }
    },
    async queryList() {
      const { result } = await this.$store.dispatch(
        "tagDataCalcRuleInfoQueryPageList",
        {
          sysCategoryFrontendDisplayId: this.nodeData.attrId,
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          calcName: this.calcName,
        }
      );
      if (result) {
        const { records, total } = result;
        this.list = records;
        this.list.forEach((v) => {
          if (v.lastSuccRecord) {
            v.resultRowsNum = v.lastSuccRecord.resultRowsNum;
            v.updateTime = v.lastSuccRecord.updateTime || v.updateTime;
            v.operatingEmployeeId =
              v.lastSuccRecord.operatingEmployeeId || v.createBy;
          }
        });
        this.list = JSON.parse(JSON.stringify(this.list));
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.switchTab();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.switchTab();
    },
    sortBy(field) {
      //根据传过来的字段进行排序,y-x 得分从高到低，x-y 从低到高
      return (x, y) => {
        return x[field] - y[field];
      };
    },
    async extractTagDataTask(row) {
      this.$message({
        message: "处理标签中...",
        type: "info",
      });
      const { code, errMsg } = await this.$store.dispatch(
        "extractTagDataTask",
        {
          tagDataId: row.id,
        }
      );
      if (code === "0") {
        this.$message({
          message: errMsg,
          type: "success",
        });
      }
    },
    async exportTagDataCsv(row) {
      this.exportRow = row;
      this.exportTypeDialog = true;
      // const { code, result } = await this.$store.dispatch(
      //   "downloadPeoplePackageResult",
      //   {
      //     schedulingId: row.id
      //   }
      // );
      // if (code === "0") {
      //   if (result) {
      //     this.save(result);
      //   }
      // }
    },
    async handleConfirmExport() {
      let params = {};
      // 静态人群
      if (this.listType === "personStatic") {
        params = {
          tagStaticId: this.exportRow.id,
          type: "static",
        };
      } else {
        params = {
          schedulingId: this.exportRow.id,
          type: "trends",
        };
      }
      if (this.exportType === "zdy") {
        if (this.exportTableCheckList.length < 1) {
          return this.$message.warning("请至少选择一个导出表头");
        }
        const { code, result } = await this.$store.dispatch(
          "downloadPeoplePackageResult",
          {
            ...params,
            exportFieldList: this.exportTableCheckList,
          }
        );
        if (code === "0") {
          if (result) {
            this.save(result);
          }
        }
      } else {
        const { code, result } = await this.$store.dispatch(
          "downloadPeoplePackageResult",
          params
        );
        if (code === "0") {
          if (result) {
            this.save(result);
          }
        }
      }
    },
    save(row) {
      axios({
        method: "post",
        url: this.$serverAdress + `/sys/common/download?filePath=${row.path}`,
        responseType: "arraybuffer",
      }).then((res) => {
        this.download(res.data, row.name);
      });
    },
    download(data, name) {
      if (!data) {
        return;
      }
      console.log("data:", data);
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      console.log("url:", url);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    async showUpdate(row) {
      let params = {
        calcRuleId: row.id,
      };
      const { code } = await this.$store.dispatch(
        "tagOperateExecPeoplePackage",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.queryList();
      }
    },
    async updateDetail() {
      if (this.currentRows && this.currentRows.id) {
        this.reportConfigIdList = [];
        this.reportConfigIdList.push(this.currentRows.id);
      }
      if (!this.reportConfigIdList.length) {
        this.$message({
          message: "更新失败,无ID",
          type: "warning",
        });
        return;
      }
      if (!this.reportResultName) {
        this.$message({
          message: "请输入人群包命名",
          type: "warning",
        });
        return;
      }
      let params = {
        reportConfigIdList: this.reportConfigIdList,
        reportResultName: this.reportResultName,
      };
      const { code } = await this.$store.dispatch(
        "execPeoplePackageCalc",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.dialogVisibleReportResultName = false;
        this.dialogVisibleReportMsg = true;
        this.switchTab();
      }
    },
    handleClose2() {
      this.dialogVisibleReportResultName = false;
    },
    handleClose3() {
      this.dialogVisible3 = false;
    },
    handleClose4() {
      this.dialogVisible4 = false;
    },
    closeDialogVisibleReportMsg() {
      this.dialogVisibleReportMsg = false;
      this.switchTab();
    },
    /**
     * @desc 删除人群
     */
    handleDel(row) {
      // 动态人群
      if (this.listType === "person") {
        this.$store
          .dispatch("checkUsageTagDataCalcRuleInfo", { id: row.id })
          .then((res) => {
            if (!Object.keys(res.result).length) {
              this.$confirm(
                "确认删除吗?删除后将无法找回该人群计算规则",
                "提示",
                {
                  confirmButtonText: "确定删除",
                  cancelButtonText: "我再想想",
                  customClass: "warning",
                  type: "warning",
                }
              ).then(() => {
                this.$store
                  .dispatch("delCalcTagAllInfoById", { id: row.id })
                  .then((res2) => {
                    if (res2.code === "0") {
                      this.listTypeTab();
                      this.$message({
                        type: "success",
                        message: "删除成功!",
                      });
                    }
                  });
              });
            } else {
              this.$message.warning(
                "当前人群正在被其他营销或者导购任务使用，不可删除"
              );
            }
          });
      } else {
        // 静态人群
        this.$store
          .dispatch("checkUsageTagCustomSourceInfo", { id: row.id })
          .then((res) => {
            console.log(res);
            if (!Object.keys(res.result).length) {
              this.$confirm(
                "确认删除吗?删除后将无法找回该人群计算规则",
                "提示",
                {
                  confirmButtonText: "确定删除",
                  cancelButtonText: "我再想想",
                  customClass: "warning",
                }
              ).then(() => {
                this.$store
                  .dispatch("delAllInfoById", { id: row.id })
                  .then((res2) => {
                    if (res2.code === "0") {
                      this.listTypeTab();
                      this.$message({
                        type: "success",
                        message: "删除成功!",
                      });
                    }
                  });
              });
            } else {
              this.$message.warning(
                "当前人群正在被其他营销或者导购任务使用，不可删除"
              );
            }
          });
      }
      // console.log(row);
      // if (row.id) {
      //   this.$message.warning('当前人群正在被其他营销或者导购任务使用，不可删除')
      // } else {
      //   this.$confirm('确认删除吗?删除后将无法找回该人群计算规则', '提示', {
      //     confirmButtonText: '确定删除',
      //     cancelButtonText: '我再想想',
      //     // type: 'warning'
      //   }).then(() => {
      //     this.$message({
      //       type: "success",
      //       message: "删除成功!"
      //     });
      //   });
      // }
    },
    async queryReportsList(row) {
      if (row) {
        this.row = row;
      }
      let params = {
        schedulingTypeId: this.row.id,
        pageNo: this.currentPageReports,
        pageSize: this.pageSizeReports,
        execMode: "manual",
      };
      const { result } = await this.$store.dispatch(
        "scrmSchedulingRecordQueryPageList",
        params
      );
      this.reportsList = result.records;
      this.totalReports = result.total;
      this.dialogVisible = true;
    },
    pagingReports(page) {
      this.currentPageReports = page;
      this.queryReportsList();
    },
    handleSizeChangeReports(size) {
      this.currentPageReports = 1;
      this.pageSizeReports = size;
      this.queryReportsList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    listTypeTab() {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.currentPage = 1;
      this.switchTab();
    },
    switchTab() {
      if (this.listType === "person") {
        this.queryList();
      } else if (this.listType === "personStatic") {
        this.queryListStatic();
      }
    },
    async queryParentId2() {
      const { result } = await this.$store.dispatch(
        "sysCategoryFrontendDisplayInfoQueryByName",
        {
          categoryName: "人群包根节点",
        }
      );
      if (result) {
        this.parentId2 = result.id;
        this.ruleForm.parentId = result.id;
      }
    },
    onGroupCommand(e, node) {
      if (node.id === "1") {
        this.msgInfo("默认分组不可操作！");
        return;
      }
      if (e == "groupEdit") {
        this.editGroup(node);
      }
      // else if (e == 'groupRemove') {
      //   this.removeGroup(node.id)
      // }
    },
    showAnalyzeList(row) {
      this.reportsRow = row;
      this.dialogVisible4 = true;
    },
    async toAnalyze(path, text) {
      console.log("path:", path);
      this.$router.push({
        path,
        query: {
          indexName: this.reportsRow.resultIndxName,
          schedulingTypeName: this.reportsRow.schedulingTypeName,
          analyzeText: text,
        },
      });
    },
    async dictItemsScrmGroupAnalysis() {
      const { code, result } = await this.$store.dispatch(
        "dictItemsScrmGroupAnalysis"
      );
      if (result) {
        this.analyzeList = result;
      }
    },
    handleSelectIcon() {
      this.$refs.iconSelect.toggleMenu();
    },
    /**
     * @desc 双击修改表格人群名称
     */
    // handleDBClick(scope) {
    //   const {$index, row} = scope
    //   console.log('双击',$index, row);
    //   this.$set(this.list[$index], 'showInput', true)
    // },
    /**
     * @desc 双击某一单元格
     */
    handleCellDBClick(row, column, cell, event) {
      console.log(row, column, cell, event);
      if (column.label == "人群名称") {
        row.showInput = true;
        this.$forceUpdate();
      }
    },
    /**
     * @desc Input 失去焦点时触发
     */
    handleInputBlur(row) {
      console.log(row);
      if (this.listType === "personStatic") {
        if (!row.tagName) {
          return this.$message.error("请输入人群名称");
        }
        const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
        if (!reg.test(row.tagName)) {
          return this.$message.error("人群名称只能包含英文、中文和数字");
        }
      } else {
        if (!row.calcName) {
          return this.$message.error("请输入人群名称");
        }
        const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
        if (!reg.test(row.calcName)) {
          return this.$message.error("人群名称只能包含英文、中文和数字");
        }
      }
      this.$confirm("是否确定修改该人群名称？", "提示", {
        confirmButtonText: "确定修改",
        cancelButtonText: "我再想想",
        customClass: "warning",
        type: "warning",
      })
        .then(async () => {
          row.showInput = false;
          this.$forceUpdate();
          console.log("blur", row.showInput);
          if (row.calcName === this.changeTableObj[row.id]) {
            return;
          }
          // 静态人群
          if (this.listType === "personStatic") {
            await this.$store.dispatch("editTagCustomSourceInfo", {
              id: row.id,
              tagName: row.tagName,
            });
          } else {
            // 动态人群
            await this.$store.dispatch("editTagDataCalcRuleInfo", {
              id: row.id,
              calcName: row.calcName,
            });
          }
          console.log("change", row.calcName);
          this.$set(this.changeTableObj, row.id, "");
          this.listTypeTab();
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        })
        .catch(() => {
          if (this.listType === "personStatic") {
            row.tagName = this.changeTableObj[row.id];
          } else {
            row.calcName = this.changeTableObj[row.id];
          }
          this.$message({
            type: "info ",
            message: "取消修改!",
          });
          row.showInput = false;
          this.$forceUpdate();
        });
    },
    /**
     * @desc Input 获得焦点时触发
     */
    handleFocus(row) {
      if (!this.changeTableObj[row.id]) {
        this.$set(this.changeTableObj, row.id, row.calcName || row.tagName);
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
  .g-card {
    border-radius: var(--border-radius-big);
    background: #fff;
    overflow: auto;
    padding: 20px;
    scroll-behavior: smooth
}
.scrm-intro .title {
    font-size: 20px;
    font-weight: 700;
    margin-right: 20px
}

.scrm-intro .title {
    font-size: 20px;
    font-weight: 700;
    margin-right: 20px
}
.scrm-intro .subTitle {
    font-size: 16px;
    color: #0081e5;
}

.scrm-intro .content {
    font-size: 14px;
    color: #999
}
.scrm-intro .title {
    font-size: 20px;
    font-weight: 700;
    margin-right: 20px
}
.left-content {
  padding: 20px;
  background: #ffffff;
  border-radius: var(--border-radius-big);
  // margin: 20px;
}
.relative {
  position: relative;
}
.margin20 {
  margin: 20px;
}
.marginleft0 {
  margin-left: 0;
}
.right-content {
  border-bottom: solid 1px #e9eef7;
  padding-bottom: 15px;
}
.right-title {
  font-size: 18px;
  color: #222222;
  line-height: 28px;
  .tips {
    color: #00a870;
    background: #e8f8f2;
    padding: 5px 10px;
    margin-left: 20px;
    border-radius: 4px;
  }
}
.gray {
  color: #999999;
}
.progress-list {
  .progress-item {
    margin-top: 20px;
    .title {
      width: 70px;
      text-align: right;
      display: inline-block;
      margin-right: 20px;
    }
    .progress {
      width: 500px;
      margin-right: 20px;
    }
    .num {
      display: inline-block;
    }
  }
}
.empty {
  text-align: center;
}
.font14 {
  font-size: 14px;
}
/deep/ .el-tree-node {
  position: relative;
  height: 40px;
}
/deep/ .el-tree-node__content {
  height: 40px;
}
.dropdown {
  position: absolute;
  right: 0;
  top: 12px;
}
.content-icon {
  transform: rotate(90deg);
}

.dialog-title {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 10px;
}
.dialog-content {
  margin-bottom: 10px;
  padding: 0 10px;
  .second_title {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .second_content {
    // padding: 0 10px;
  }
}
</style>
  
  <style lang="scss">
/deep/ .tag-dialog {
  background: #000;
  /deep/ .el-dialog__body {
    margin: 0;
  }
}

.select-div {
  position: absolute;
  top: 0;
  width: 220px;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
.warning {
  color: #f56c6c;
}

.radio-wrap {
  .radio-title {
    font-size: 14px;
    color: #222222;
  }
}
.zdy-wrap {
  margin-top: 20px;
  ._title {
    margin-bottom: 10px;
    position: relative;
    padding-left: 10px;
    font-weight: 500;
    font-size: 14px;
    color: #222222;
    &::before {
      content: "";
      width: 3px;
      height: 16px;
      background: #3180ff;
      border-radius: 8px 8px 8px 8px;
      position: absolute;
      left: 0;
    }
  }
  .el-checkbox {
    margin-bottom: 6px;
  }
}
</style>
  <style lang="scss">
.warning {
  .el-message-box__message {
    color: #f56c6c;
  }
}
</style>
